import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { useFindMatchingContactFieldsQuery } from "../store/slices/contactsSlice";
// import JsonCollapse from "../Builder/Components/JsonCollapse";

export default function SolutionImportCheckContactField({
  importedJSON,
  setImportedJSON,
  fieldkey: key,
  value,
  manualFields,
  setManualFields,
}: {
  importedJSON: any;
  setImportedJSON: React.Dispatch<React.SetStateAction<any>>;
  fieldkey: string;
  value: any;
  manualFields: string[];
  setManualFields: React.Dispatch<React.SetStateAction<string[]>>;
}) {
  // Fetch matching contact fields
  const contactFields =
    useFindMatchingContactFieldsQuery(
      importedJSON.Item.ContactFields.find((f: any) => f.uuid === key)
    )?.data?.fields || [];

  return (
    <>
      <InputGroup as="row">
        <InputGroupText className="col-3">
          {
            importedJSON.Item.ContactFields.find((f: any) => f.uuid === key)
              ?.label
          }
        </InputGroupText>
        {!value && !manualFields.includes(key) ? (
          <InputGroupText className="text-muted col" style={{ height: 40 }}>
            This field will be created automatically upon deployment. Or you can{" "}
            <button
              className="btn btn-link p-0 align-baseline ms-1"
              onClick={() => {
                setManualFields((prev) => [...prev, key]);
              }}
            >
              manage manually
            </button>
            .
          </InputGroupText>
        ) : manualFields.includes(key) ? (
          <div className="col ms-n1">
            <div className="mb-2">
              <Form.Check
                inline
                type="radio"
                id={`${key}-select-existing`}
                label="Select existing field"
                name={`${key}-field-choice`}
                checked={
                  value !== null &&
                  value !== undefined &&
                  !value.startsWith("NEW:")
                }
                onChange={() => {
                  setImportedJSON((prev: any) => {
                    const updated = { ...prev };
                    updated.Bag.External.ContactField[key] = "";
                    return updated;
                  });
                }}
              />
              <Form.Check
                inline
                type="radio"
                id={`${key}-create-new`}
                label="Create new field"
                name={`${key}-field-choice`}
                checked={
                  value === null ||
                  value === undefined ||
                  value.startsWith("NEW:")
                }
                onChange={() => {
                  setImportedJSON((prev: any) => {
                    const updated = { ...prev };
                    updated.Bag.External.ContactField[key] = "NEW:";
                    return updated;
                  });
                }}
              />
            </div>
            {value === "" || (value && !value.startsWith("NEW:")) ? (
              contactFields && (
                <Input
                  placeholder="Select an existing contact field"
                  inputType="select"
                  value={[value]}
                  onChange={([v]: any) => {
                    setImportedJSON((prev: any) => {
                      const updated = { ...prev };
                      updated.Bag.External.ContactField[key] = v;
                      return updated;
                    });
                  }}
                  options={contactFields?.map((cf: any) => ({
                    value: cf.uuid,
                    label: cf.label,
                  }))}
                />
              )
            ) : (
              <Form.Control
                type="text"
                placeholder="Enter a name for the new field"
                value={value?.startsWith("NEW:") ? value.substring(4) : ""}
                onChange={(e) => {
                  const newValue = e.target.value.trim();
                  setImportedJSON((prev: any) => {
                    const updated = { ...prev };
                    updated.Bag.External.ContactField[key] = newValue
                      ? `NEW:${newValue}`
                      : "NEW:";
                    return updated;
                  });
                }}
              />
            )}
          </div>
        ) : (
          <div className="col ms-n1">
            {contactFields && (
              <Input
                placeholder="Select an existing contact field"
                inputType="select"
                value={[value]}
                onChange={([v]: any) => {
                  setImportedJSON((prev: any) => {
                    const updated = { ...prev };
                    updated.Bag.External.ContactField[key] = v;
                    return updated;
                  });
                }}
                options={contactFields?.map((cf: any) => ({
                  value: cf.uuid,
                  label: cf.label,
                }))}
              />
            )}
          </div>
        )}
        <div className="col-auto d-flex justify-content-end align-items-center">
          <Form.Check
            id={`contact-field-manual-${key}`}
            type="switch"
            label="Manage manually"
            checked={manualFields.includes(key)}
            onChange={(e) => {
              if (e.target.checked) {
                setManualFields((prev) => [...prev, key]);
              } else {
                setManualFields((prev) => prev.filter((f) => f !== key));

                // remove values
                const oldField = importedJSON.Item.ContactFields.find(
                  (f: any) => f.uuid === key
                );
                setImportedJSON((prev: any) => {
                  const updated = { ...prev };
                  updated.Bag.External.ContactField[key] = "";

                  for (const fieldKey of Object.keys(
                    updated.Bag.External.ContactFieldOption
                  )) {
                    const fieldMapping = oldField.options?.find(
                      (f: any) => f.uuid === fieldKey
                    );
                    if (fieldMapping) {
                      updated.Bag.External.ContactFieldOption[fieldKey] = "";
                    }
                  }

                  return updated;
                });
              }
            }}
            className="ms-3"
          />
        </div>
      </InputGroup>
      {/* <div className="overflow-auto">
        <div>
          <JsonCollapse
            defaulPlainText
            label="needed"
            json={importedJSON.Item.ContactFields.find(
              (f: any) => f.uuid === key
            )}
          />
        </div>
        <div>
          <JsonCollapse
            defaulPlainText
            label="selected"
            json={contactFields?.find((f: any) => f.uuid === value)}
          />
        </div>
      </div> */}
      {importedJSON.Item.ContactFields.find((f: any) => f.uuid === key)
        ?.is_select &&
        manualFields.includes(key) && (
          <div key={value} className="mb-5 ms-4 border-start ps-3">
            {importedJSON.Bag.External.ContactFieldOption && (
              <h4 className="mt-3">Select field options</h4>
            )}
            {/* <JsonCollapse
              defaulPlainText
              json={Object.entries(
                importedJSON.Bag.External.ContactFieldOption || {}
              ).filter(([key2, value2]: [string, any]) =>
                importedJSON.Item.ContactFields.some(
                  (f: any) =>
                    f.uuid === key &&
                    f.options.find((ff: any) => ff.uuid === key2)
                )
              )}
            /> */}
            {Object.entries(importedJSON.Bag.External.ContactFieldOption || {})
              .filter(([key2, value2]: [string, any]) =>
                importedJSON.Item.ContactFields.some(
                  (f: any) =>
                    f.uuid === key &&
                    f.options.find((ff: any) => ff.uuid === key2)
                )
              )
              .map(([key2, value2]: [string, any]) => (
                <div key={key2} className="mb-3">
                  <InputGroup>
                    <InputGroupText className="col-3">
                      {
                        importedJSON.Item.ContactFields.find(
                          (f: any) => f.uuid === key
                        )?.options.find((f: any) => f.uuid === key2)?.label
                      }
                    </InputGroupText>
                    {!value && !manualFields.includes(key) ? (
                      <InputGroupText className="text-muted">
                        This option will be created automatically upon
                        deployment. Or you can{" "}
                        <button
                          className="btn btn-link p-0 align-baseline ms-1"
                          onClick={() => {
                            setManualFields((prev) => [...prev, key]);
                          }}
                        >
                          manage manually
                        </button>
                        .
                      </InputGroupText>
                    ) : (
                      <div className="col ms-n1">
                        <Input
                          placeholder="Select an existing option or type a name and select Create"
                          inputType="select"
                          value={[value2]}
                          onChange={([v]: any) => {
                            setImportedJSON((prev: any) => {
                              const updated = { ...prev };
                              updated.Bag.External.ContactFieldOption[key2] = v;
                              return updated;
                            });
                          }}
                          options={contactFields
                            .find((f: any) => f.uuid === value)
                            ?.options?.map((cf: any) => ({
                              value: cf.uuid,
                              label: cf.label,
                            }))}
                        />
                      </div>
                    )}
                  </InputGroup>
                  {/* <div className="overflow-auto">
                    <div>
                      <JsonCollapse
                        defaulPlainText
                        label="needed"
                        json={importedJSON.Item.ContactFields.find(
                          (f: any) => f.uuid === key
                        )?.options.find((f: any) => f.uuid === key2)}
                      />
                    </div>
                    <div>
                      <JsonCollapse
                        defaulPlainText
                        label="selected"
                        json={contactFields
                          .find((f: any) => f.uuid === value)
                          ?.options.find((f: any) => f.uuid === value2)}
                      />
                    </div>
                  </div> */}
                </div>
              ))}
          </div>
        )}
    </>
  );
}
